import { render, staticRenderFns } from "./PartnersTabs.vue?vue&type=template&id=cdf0e3e8"
import script from "./PartnersTabs.vue?vue&type=script&lang=js"
export * from "./PartnersTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports